import { NgModule } from '@angular/core';
import {
	ActivitySourceDialogComponent
} from '@go-modules/components/dialogs/activity-source-dialog/activity-source-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		ActivitySourceDialogComponent
	],
	exports: [
		ActivitySourceDialogComponent
	]
})
export class ActivitySourceDialogModule {}
